module.exports = __webpack_public_path__ + "img/ref-cll.bea0849b.png";